/**
 * Category groupings for the main menu. Aligned with Settings sidebar categories.
 */
export type MenuCategory = "Getting Started" | "Marketing" | "Sales" | "Operations" | "Systems";

export const CATEGORY_ORDER: MenuCategory[] = [
  "Getting Started",
  "Marketing",
  "Sales",
  "Operations",
  "Systems",
];

/** Map top-level menu id → category. Defaults to Operations for unknown ids. */
export const MENU_ID_TO_CATEGORY: Partial<Record<string, MenuCategory>> = {
  dashboard: "Getting Started",
  newsfeedStatic: "Getting Started",
  "start-here": "Getting Started",
  "annotations-group": "Operations",
  "brand-management": "Operations",
  "performance-marketing": "Marketing",
  "content-marketing": "Marketing",
  badges: "Marketing",
  "social-media": "Marketing",
  seo: "Marketing",
  saio: "Marketing",
  cla: "Marketing",
  "cro-ux": "Marketing",
  "fact-checker": "Marketing",
  "synthetic-personas": "Marketing",
  "focus-groups": "Marketing",
  "planning-budgeting": "Sales",
  "digital-operations": "Operations",
  "sales-operations": "Sales",
  meetings: "Operations",
  "sops-templates": "Operations",
  "reporting-hub": "Operations",
  "personal-cards": "Sales",
  collaborations: "Marketing",
  "growth-hacking": "Systems",
  digcomp: "Systems",
  "link-building": "Marketing",
  "cold-outreach": "Marketing",
  "referral-system": "Marketing",
  "tool-site-audit": "Operations",
  "documentation-hub": "Operations",
  "embeddable-widgets": "Marketing",
  "scale-2y3x": "Systems",
  "local-stores": "Sales",
  "learning-center": "Sales",
  "human-resources": "Operations",
  "internal-training": "Operations",
  surveys: "Marketing",
  tools: "Operations",
  "support-portal": "Operations",
  "360": "Systems",
  "podcast-hosting": "Marketing",
  events: "Marketing",
};

/** Fixed order for "Getting Started" items: Today's News, Dashboard, Start here */
export const GETTING_STARTED_ORDER = ["newsfeedStatic", "dashboard", "start-here"];

export function getMenuCategory(menuId: string): MenuCategory {
  return MENU_ID_TO_CATEGORY[menuId] ?? "Operations";
}
